import api, { apiPrefix } from './Api';
import {
  Suggestions,
  suggestionsFromResponse,
} from '../interfaces/Suggestion/Suggestions';

const suggestionApiPrefix = `${apiPrefix  }/suggestions`;

export const getSuggestions = async (
  searchValue: string,
): Promise<Suggestions> => {
  const response = await api.get(suggestionApiPrefix, {
    params: { query: searchValue },
  });

  return suggestionsFromResponse(response.data);
};
